import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useInsertBasket = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const insertRequest = (
    guid,
    getBasketList,
    basketName,
    basketType,
    onSuccess,
    // eslint-disable-next-line max-params
  ) => {
    setLoading(true);
    axiosClient
      .post(`InventoryShoppingCart/Insert`, {
        zoneGuid: guid,
        display: basketName,
        type: basketType,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`افزودن با موفقیت انجام شد`, { variant: 'success' });
          getBasketList();
          onSuccess();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [insertRequest, loading];
};

export default useInsertBasket;
